import {useEffect, useState} from "react";
import {useAuth0} from "@auth0/auth0-react";

export default function useEmail() {
    const [email, setEmail] = useState(null);
    const {isLoading, isAuthenticated, getIdTokenClaims} = useAuth0()

    useEffect(() => {
        if (!isLoading && isAuthenticated)
        {
            getIdTokenClaims().then((claims) => setEmail(claims.email))
        }
    }, [isLoading, isAuthenticated]);

    return email;
}